export type Content = {
  author_name: string;
  author_slug: string;
  authors_string: string;
  bookmarked: boolean;
  has_access: boolean;
  has_audio: boolean;
  has_recommendation: boolean;
  has_text: boolean;
  has_video: boolean;
  id: string;
  object: string;
  program_slug: string;
  program_title: string;
  program_type: string;
  program_type_trans: string;
  progress?: {
    next_content: {
      slug: string;
    };
    total_percentage: number;
  };
  published_at: string;
  slug: string;
  summary: string;
  thumb: string;
  title: string;
  view_time: string;
  watch: Watch;
  content_count: number;
};

export type Watch = {
  total: string;
  progress: string;
  percentage: number;
};

export const ENTERTAINMENT_CONTENT_TYPES = [
  'movie',
  'series',
  'interview',
  'podcast',
  'event',
];
export const EDUCATIONAL_CONTENT_TYPES = ['course', 'tutorial'];
